import React from 'react';
import TableView from './TableView';

function TableChart({ width, height, data }) {
  let content;
console.log(data)
  try {
    if (!data || typeof data !== 'object') {
      throw new Error("Invalid data format");
    }

    const rows = data || [];

    content = (
      <>
        <TableView width={width} height={height} rows={rows} />
        <div className="over-flow"></div>
      </>
    );
  } catch (error) {
    console.error("Error in TableChart:", error);
    content = <div style={{ color: 'red' }}>  Something went wrong. Use Another favorite prompt to generate</div>
  }

  return content;
}

export default TableChart;
